import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import Button from "@mui/material/Button";
import "./Customerservice.css";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import {
  ButtonBase,
  Divider,
  FormControl,
  Grid,
  InputLabel,
} from "@mui/material";
import { Box } from "@mui/system";
import CommonButton from "../../../../Componants/Common/Button";
import InputFileUpload from "../../../../Componants/Common/Bulk Upload/InputFileUpload";
import CustomDatePicker from "../../../../Componants/Common/Custom Date Picker/CustomDatePicker";
import {
  addProduct,
  createCustomers,
  fetchBrandListDropdown,
  fetchCategoryListDropdown,
  fetchSubCategoryListDropdown,
  fetchModelListDropdown,
  getCountryListDrop,
  getStateListDrop,
  getCityListDrop,
  singleImageUpload,
} from "../../../../API Service/apiService";
import config from "../../../../Componants/Common/config";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../../Componants/Loader/Loader";
import { DatePicker } from "antd";
import { format } from "date-fns";
import { Calendar } from "../../../../Componants/Common/Calender";
import DynamicTabs from "../../../../components/DynamicTabs";
const calltype = [];
const options = [
  { label: "Option 1" },
  { label: "Option 2" },
  { label: "Option 3" },
];
const Customerservice = () => {
  const pageSize = config.pageSize;
  const [countriesActive, setCountriesActive] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const [countryId, setCountryId] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [cityId, setCityId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [activeBrandList, setActiveBrandList] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [filteredCat, setFilteredCat] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [filteredSubCat, setFilteredSubCat] = useState([]);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null);
  const [filteredModel, setFilteredModel] = useState([]);
  const [selectedModelId, setSelectedModelId] = useState(null);
  const [customerID, setCustomerID] = useState(null);
  const [imageValue, setImageValue] = useState([]);
  const [isCustomerCreated, setIsCustomerCreated] = useState(false);
  const [formDataCustomer, setFormDataCustomer] = useState({
    customerName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    landmark: "",
    gstNumber: "",
  });

  const [formErrors, setFormErrors] = useState({
    customerName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    gstNumber: "",
  });

  const [formDataProduct, setFormDataProduct] = useState({
    customerId: "",
    brandId: "",
    categoryId: "",
    subcategoryId: "",
    modelId: "",
    invoiceDate: "",
    invoiceNo: "",
    serialNo: "",
    purchasedFrom: "",
    image: null, // Set image to null initially
  });

  const [productErrors, setProductErrors] = useState({
    brandId: "",
    categoryId: "",
    subcategoryId: "",
    modelId: "",
    invoiceDate: "",
    invoiceNo: "",
    serialNo: "",
    purchasedFrom: "",
    image: "",
  });

  const [showProductDetails, setShowProductDetails] = useState(false);
  const [productCreated, setProductCreated] = useState(false);
  const [isProductSet, setIsProductSet] = useState(false);
  useEffect(() => {
    fetchCountries();
    fetchBrandList();
  }, []);

  useEffect(() => {
    if (countryId) fetchStates();
  }, [countryId]);

  useEffect(() => {
    if (stateId) fetchCities();
  }, [stateId]);

  useEffect(() => {
    if (selectedBrandId) fetchCategoriesList();
  }, [selectedBrandId]);

  useEffect(() => {
    if (selectedCategoryId) fetchSubCategoriesList();
  }, [selectedCategoryId]);

  useEffect(() => {
    if (selectedSubCategoryId) fetchModelsList();
  }, [selectedSubCategoryId]);

  const fetchCountries = async () => {
    try {
      setLoading(true);
      const response = await getCountryListDrop({ dropdown: true });
      setCountriesActive(response.data.countries);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    try {
      setLoading(true);
      const response = await getStateListDrop({ countryId, dropdown: true });
      setStates(response.data.states);
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCities = async () => {
    try {
      setLoading(true);
      const response = await getCityListDrop({
        stateId,
        countryId,
        dropdown: true,
      });
      setCities(response.data.cities);
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBrandList = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandListDropdown({ dropdown: true });
      const activeBrands = response.data.brandList.filter(
        (brand) => brand.active
      );
      setActiveBrandList(activeBrands);
    } catch (error) {
      console.error("Error fetching brand list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoriesList = async () => {
    if (!selectedBrandId) return; // Ensure brandId is set
    try {
      setLoading(true);
      const response = await fetchCategoryListDropdown(selectedBrandId);
      setFilteredCat(response.data.categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCategoriesList = async () => {
    try {
      setLoading(true);
      const response = await fetchSubCategoryListDropdown({
        brandId: selectedBrandId,
        categoryId: selectedCategoryId,
        dropdown: true,
      });
      setFilteredSubCat(response.data.subcategory);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchModelsList = async () => {
    try {
      setLoading(true);
      const response = await fetchModelListDropdown({
        brandId: selectedBrandId,
        categoryId: selectedCategoryId,
        subcategoryId: selectedSubCategoryId,
        dropdown: true,
      });
      setFilteredModel(response.data.models);
    } catch (error) {
      console.error("Error fetching models:", error);
    } finally {
      setLoading(false);
    }
  };

  const calltypeDefaultProps = {
    options: calltype,
    getOptionLabel: (option) => option.title,
  };

  const handleCreateCustomer = async () => {
    // Reset all errors
    setFormErrors({
      customerName: "",
      mobileNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      gstNumber: "",
    });

    let hasErrors = false;
    let newErrors = {
      customerName: "",
      mobileNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      gstNumber: "",
    };

    // Validate customer name (required and max 50 chars)
    if (!formDataCustomer.customerName) {
      newErrors.customerName = "Customer name is required";
      hasErrors = true;
    } else if (formDataCustomer.customerName.length > 50) {
      newErrors.customerName = "Customer name cannot exceed 50 characters";
      hasErrors = true;
    }

    // Validate mobile number (required, numeric, and exactly 10 digits)
    if (!formDataCustomer.mobileNumber) {
      newErrors.mobileNumber = "Mobile number is required";
      hasErrors = true;
    } else if (!/^\d{10}$/.test(formDataCustomer.mobileNumber)) {
      newErrors.mobileNumber = "Mobile number must be exactly 10 digits";
      hasErrors = true;
    }

    // Validate email (required and valid format)
    if (!formDataCustomer.email) {
      newErrors.email = "Email is required";
      hasErrors = true;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formDataCustomer.email)
    ) {
      newErrors.email = "Please enter a valid email address";
      hasErrors = true;
    }

    // Validate address (required and max 100 chars)
    if (!formDataCustomer.address) {
      newErrors.address = "Address is required";
      hasErrors = true;
    } else if (formDataCustomer.address.length > 100) {
      newErrors.address = "Address cannot exceed 100 characters";
      hasErrors = true;
    }

    // Validate other required fields
    const requiredFields = ["city", "state", "country", "pincode"];
    for (const field of requiredFields) {
      if (!formDataCustomer[field]) {
        newErrors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required`;
        hasErrors = true;
      }
    }

    // Validate pincode (numeric)
   if (formDataCustomer.pincode) {
  if (!/^\d+$/.test(formDataCustomer.pincode)) {
    newErrors.pincode = "Pincode must contain only numbers";
    hasErrors = true;
  } else if (formDataCustomer.pincode.length !== 6) {
    newErrors.pincode = "Pincode must be exactly 6 digits";
    hasErrors = true;
  }
}

if (formDataCustomer.gstNumber?.trim()) {
  const gst = formDataCustomer.gstNumber.trim().toUpperCase();
  const gstRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  if (!gstRegex.test(gst)) {
    newErrors.gstNumber =
      "Invalid GST number format (e.g., 22AAAAA0000A1Z5)";
    hasErrors = true;
  }
}

    if (hasErrors) {
      setFormErrors(newErrors);
      return;
    }

    try {
      setLoading(true);
      const response = await createCustomers(formDataCustomer);

      if (response.status === "success") {
        toast.success("Customer created successfully,Please Add Product");
        setIsCustomerCreated(true);
        
        // Get the inserted customer ID
        const insertedId = response.data.insertedId;
        setCustomerID(insertedId);
        
        // Don't automatically show product details - wait for user to click Add Product
        setShowProductDetails(false);

        // Save `customerId` locally
        localStorage.setItem("customerId", insertedId);

        // Update state
        setFormDataProduct((prev) => ({
          ...prev,
          customerId: insertedId,
        }));
      }
      setFormDataCustomer({
        customerName: "",
        mobileNumber: "",
        email: "",
        address: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        landmark: "",
        gstNumber: "",
      });
      setSelectedCountry(null);
      setSelectedState(null);
      setSelectedCity(null);
      // setIsProductSet(false);
    } catch (error) {
      console.error("Error creating customer:", error);
      
      // Check if the error response has the specific error format
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        // Handle the specific case where a customer with the same mobile number already exists
        if (errorData.status === "error" && errorData.message === "Customer with this mobile number already exists") {
          toast.error(errorData.message);
          // Highlight the mobile number field with an error
          setFormErrors(prev => ({
            ...prev,
            mobileNumber: errorData.message
          }));
        } else if (errorData.status === "error" && errorData.message) {
          // Handle other specific error messages from the API
          toast.error(errorData.message);
        } else {
          // Default error message
          toast.error("Failed to create customer");
        }
      } else {
        // Default error message if we can't extract a specific message
        toast.error("Failed to create customer");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancelCustomer = async () => {
    // Clear form data
    setFormDataCustomer({
      customerName: "",
      mobileNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      landmark: "",
      gstNumber: "",
    });

    // Clear validation errors
    setFormErrors({
      customerName: "",
      mobileNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      gstNumber: "",
    });

    // Reset dropdown selections
    setSelectedCountry(null);
    setSelectedState(null);
    setSelectedCity(null);
    
    // Reset customer and product states
    setIsCustomerCreated(false);
    setProductCreated(false);
    setIsProductSet(false);
    setShowProductDetails(false);
    
    // Reset product form
    resetProductForm();
    
    console.log("cancel customer button clicked");
  };

  const resetProductForm = () => {
    setFormDataProduct({
      customerId: "",
      brandId: "",
      categoryId: "",
      subcategoryId: "",
      modelId: "",
      invoiceNo: "",
      serialNo: "",
      purchasedFrom: "",
      image: "",
    });
    setSelectedBrandId(null);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedModelId(null);

    // Reset product errors
    setProductErrors({
      brandId: "",
      categoryId: "",
      subcategoryId: "",
      modelId: "",
      invoiceDate: "",
      invoiceNo: "",
      serialNo: "",
      purchasedFrom: "",
      image: "",
    });
  };
  const handleCreateProduct = async () => {
    // Reset product errors
    setProductErrors({
      brandId: "",
      categoryId: "",
      subcategoryId: "",
      modelId: "",
      invoiceDate: "",
      invoiceNo: "",
      serialNo: "",
      purchasedFrom: "",
      image: ""
    });
    
    let hasErrors = false;
    let newErrors = {
      brandId: "",
      categoryId: "",
      subcategoryId: "",
      modelId: "",
      invoiceDate: "",
      invoiceNo: "",
      serialNo: "",
      purchasedFrom: "",
      image: ""
    };
    
    // Validate required fields
    if (!selectedBrandId) {
      newErrors.brandId = "Brand is required";
      hasErrors = true;
    }
    
    if (!selectedCategoryId) {
      newErrors.categoryId = "Category is required";
      hasErrors = true;
    }
    
    if (!selectedSubCategoryId) {
      newErrors.subcategoryId = "Sub Category is required";
      hasErrors = true;
    }
    
    if (!selectedModelId) {
      newErrors.modelId = "Model is required";
      hasErrors = true;
    }
    
    // Validation for optional fields removed as per request
    // invoiceDate, invoiceNo, serialNo, purchasedFrom are now optional

    
    // Add image validation if needed
    if (!formDataProduct.image && imageValue.length === 0) {
      newErrors.image = "Product image is required";
      hasErrors = true;
    }
    
    if (hasErrors) {
      setProductErrors(newErrors);
      toast.error("Please fill in all required fields");
      return;
    }
    
    try {
      setLoading(true);
      let imagePath = [];
  
      if (formDataProduct.image && imageValue.length === 0) {
        const formData = new FormData();
        formData.append("imageType", "product");
        formData.append("image", formDataProduct.image);
  
        const response = await singleImageUpload(formData);
        if (response.data.status === "success" && response.data.data.fullPath) {
          imagePath = response.data.data.fullPath;
          setImageValue(imagePath);
        } else {
          toast.error("Failed to upload image");
          return;
        }
      }
  
      const body = {
        customerId: localStorage.getItem("customerId"),
        brandId: selectedBrandId,
        categoryId: selectedCategoryId,
        subcategoryId: selectedSubCategoryId,
        modelId: selectedModelId,
        invoiceNo: formDataProduct.invoiceNo,
        invoiceDate: formDataProduct.invoiceDate instanceof Date ? format(formDataProduct.invoiceDate, "dd/MM/yyyy") : formDataProduct.invoiceDate,
        serialNo: formDataProduct.serialNo,
        purchasedFrom: formDataProduct.purchasedFrom,
        imagePath: imagePath.length > 0 ? imagePath : imageValue,
      };
  
      const response = await addProduct(body);
      if (response.status === "success") {
        toast.success("Product created successfully");
        setImageValue([]);
        
        // Reset form and state
        resetProductForm();
        
        // Hide product details form
        setShowProductDetails(false);
        
        // Update product creation state
        setProductCreated(true);
        
        // Update button visibility state
        setIsProductSet(false);
        
        // Keep customer created state true
        setIsCustomerCreated(false);
      } else {
        toast.error("Failed to create product");
      }
    } catch (error) {
      console.error("Error creating product:", error);
      toast.error("Failed to create product");
    } finally {
      setLoading(false);
    }
  };  

  const handleCancelProduct = () => {
    // Reset product form
    resetProductForm();
    
    // Hide product details form
    setShowProductDetails(false);
    
    // Reset product creation state
    setProductCreated(false);
    
    // Update button visibility state
    setIsProductSet(false);

    // Clear product validation errors
    setProductErrors({
      brandId: "",
      categoryId: "",
      subcategoryId: "",
      modelId: "",
      invoiceDate: "",
      invoiceNo: "",
      serialNo: "",
      purchasedFrom: "",
      image: "",
    });
  };

  const handleAddProduct = () => {
    // Reset product form before showing it
    resetProductForm();
    
    // Show product details form
    setShowProductDetails(true);
    
    // Reset product creation state
    setProductCreated(false);
    
    // Update button visibility state
    setIsProductSet(true);
  };

  const handleCancelProductDetails = () => {
    // Hide product details form
    setShowProductDetails(false);
    
    // Update button visibility state
    setIsProductSet(false);
    
    // Reset product form
    resetProductForm();
  };

  // Generic handler for updating form fields
  const handleChange = (fieldName, value) => {
    setFormDataProduct((prevState) => ({
      ...prevState,
      [fieldName]: value, // Update the specific field with the new value
    }));

    // Clear the error for this field when it's changed
    if (productErrors[fieldName]) {
      setProductErrors({
        ...productErrors,
        [fieldName]: "",
      });
    }
  };

  return (
    <Grid container>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Create Customer"} />
      <DynamicTabs />
      <Grid
        container
        gap={3}
        sx={{
          background: "#EFF3FE",
          margin: "4px 10px 0 10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px 10px 10px 10px",
          fontWeight: 600,
        }}
      >
        <Box sx={{ width: "100%" }}>
          <h4>Customer Details</h4>
        </Box>

        <Grid container spacing={5}>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Customer Name *"
              variant="standard"
              value={formDataCustomer.customerName}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 50) {
                  setFormDataCustomer({
                    ...formDataCustomer,
                    customerName: value,
                  });

                  // Clear validation error
                  if (formErrors.customerName) {
                    setFormErrors({
                      ...formErrors,
                      customerName: "",
                    });
                  }
                }
              }}
              error={!!formErrors.customerName}
              helperText={formErrors.customerName}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>

          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Mobile No. *"
              variant="standard"
              value={formDataCustomer.mobileNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value) && value.length <= 10) {
                  setFormDataCustomer({
                    ...formDataCustomer,
                    mobileNumber: value,
                  });

                  // Clear validation error
                  if (formErrors.mobileNumber) {
                    setFormErrors({
                      ...formErrors,
                      mobileNumber: "",
                    });
                  }
                }
              }}
              error={!!formErrors.mobileNumber}
              helperText={formErrors.mobileNumber}
              inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Email *"
              variant="standard"
              value={formDataCustomer.email}
              onChange={(e) => {
                const value = e.target.value;
                setFormDataCustomer({
                  ...formDataCustomer,
                  email: value,
                });

                // Real-time email validation
                if (
                  value &&
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
                ) {
                  setFormErrors({
                    ...formErrors,
                    email: "Please enter a valid email address",
                  });
                } else {
                  setFormErrors({
                    ...formErrors,
                    email: "",
                  });
                }
              }}
              error={!!formErrors.email}
              helperText={formErrors.email}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              // disableCloseOnSelect
              options={countriesActive}
              getOptionLabel={(option) => option.countryName || ""}
              value={selectedCountry}
              onChange={(event, newValue) => {
                setCountryId(newValue?._id || null);
                setSelectedCountry(newValue);
                setFormDataCustomer({
                  ...formDataCustomer,
                  country: newValue?.countryName || "",
                });

                // Clear validation error
                if (formErrors.country) {
                  setFormErrors({
                    ...formErrors,
                    country: "",
                  });
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Country *"
                  variant="standard"
                  style={{ width: "12.5rem" }}
                  error={!!formErrors.country}
                  helperText={formErrors.country}
                />
              )}
            />
          </Grid>
        </Grid>

        <Grid container mt="3" spacing={4}>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              // disableCloseOnSelect
              options={states}
              getOptionLabel={(option) => option.stateName || ""}
              value={selectedState}
              onChange={(event, newValue) => {
                setStateId(newValue?._id || null);
                setSelectedState(newValue);
                setFormDataCustomer({
                  ...formDataCustomer,
                  state: newValue?.stateName || "",
                });

                // Clear validation error
                if (formErrors.state) {
                  setFormErrors({
                    ...formErrors,
                    state: "",
                  });
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="State *"
                  variant="standard"
                  style={{ width: "12.5rem" }}
                  error={!!formErrors.state}
                  helperText={formErrors.state}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              // disableCloseOnSelect
              options={cities}
              getOptionLabel={(option) => option.cityName || ""}
              value={selectedCity}
              onChange={(event, newValue) => {
                setCityId(newValue?._id || null);
                setSelectedCity(newValue);
                setFormDataCustomer({
                  ...formDataCustomer,
                  city: newValue?.cityName || "",
                });

                // Clear validation error
                if (formErrors.city) {
                  setFormErrors({
                    ...formErrors,
                    city: "",
                  });
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="City *"
                  variant="standard"
                  style={{ width: "12.5rem" }}
                  error={!!formErrors.city}
                  helperText={formErrors.city}
                />
              )}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Address *"
              variant="standard"
              value={formDataCustomer.address}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 100) {
                  setFormDataCustomer({
                    ...formDataCustomer,
                    address: value,
                  });

                  // Clear validation error
                  if (formErrors.address) {
                    setFormErrors({
                      ...formErrors,
                      address: "",
                    });
                  }
                }
              }}
              error={!!formErrors.address}
              helperText={formErrors.address}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>

          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Pin Code *"
              variant="standard"
              value={formDataCustomer.pincode}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setFormDataCustomer({
                    ...formDataCustomer,
                    pincode: value,
                  });

                  // Clear validation error
                  if (formErrors.pincode) {
                    setFormErrors({
                      ...formErrors,
                      pincode: "",
                    });
                  }
                }
              }}
              error={!!formErrors.pincode}
              helperText={formErrors.pincode}
              inputProps={{ pattern: "[0-9]*" }}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="Landmark"
              variant="standard"
              value={formDataCustomer.landmark}
              onChange={(e) =>
                setFormDataCustomer({
                  ...formDataCustomer,
                  landmark: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="standard-basic"
              label="GSTIN No."
              variant="standard"
              value={formDataCustomer.gstNumber}
              onChange={(e) => {
                const value = e.target.value;
                setFormDataCustomer({
                  ...formDataCustomer,
                  gstNumber: value,
                });

                // Clear validation error
                if (formErrors.gstNumber) {
                  setFormErrors({
                    ...formErrors,
                    gstNumber: "",
                  });
                }
              }}
              error={!!formErrors.gstNumber}
              helperText={formErrors.gstNumber}
            />
          </Grid>
        </Grid>
        <Grid container gap={2}>
          {!isCustomerCreated ? (
            // When customer is not yet created - show Create and Cancel for customer
            <>
              <Grid item>
                <CommonButton
                  name={"Create"}
                  handleOnClick={handleCreateCustomer}
                />
              </Grid>
              <Grid item>
                <CommonButton
                  name={"Cancel"}
                  handleOnClick={handleCancelCustomer}
                />
              </Grid>
            </>
          ) : !showProductDetails ? (
            // When customer is created but product details form is not shown
            // Show Cancel and Add Product buttons
            <>
              <Grid item>
                <CommonButton
                  name={"Cancel"}
                  handleOnClick={handleCancelCustomer}
                />
              </Grid>
              <Grid item>
                <Button
                  onClick={handleAddProduct}
                  style={{
                    backgroundColor: "#4CAF50",
                    color: "white",
                    borderRadius: "5px",
                    marginTop: "10px",
                    padding: "5px 10px",
                  }}
                >
                  Add Product
                </Button>
              </Grid>
            </>
          ) : (
            // When product details are shown, don't display any buttons here
            null
          )}
        </Grid>

        {/* Product Details Section - Only shown when showProductDetails is true */}
        {showProductDetails && (
          <>
            <Divider
              sx={{
                height: "1px",
                backgroundColor: "lightgray",
                width: "100%",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <h4>Product Details</h4>
            </Box>
            <Grid container mt="3" spacing={4}>
              <Grid item>
                <Autocomplete
                  id="disable-close-on-select"
                  // disableCloseOnSelect
                  options={activeBrandList}
                  getOptionLabel={(option) => option.brandName || ""}
                  value={
                    activeBrandList.find(
                      (brand) => brand._id === selectedBrandId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setSelectedBrandId(newValue?._id || null); // Extract and set only the _id

                    // Clear validation error
                    if (productErrors.brandId) {
                      setProductErrors({
                        ...productErrors,
                        brandId: "",
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Brand *"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                      error={!!productErrors.brandId}
                      helperText={productErrors.brandId}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Autocomplete
                  id="disable-close-on-select"
                  // disableCloseOnSelect
                  options={filteredCat}
                  getOptionLabel={(option) => option.categoryName || ""}
                  value={
                    filteredCat.find((cat) => cat._id === selectedCategoryId) ||
                    null
                  }
                  onChange={(event, newValue) => {
                    setSelectedCategoryId(newValue?._id || null);

                    // Clear validation error
                    if (productErrors.categoryId) {
                      setProductErrors({
                        ...productErrors,
                        categoryId: "",
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Category *"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                      error={!!productErrors.categoryId}
                      helperText={productErrors.categoryId}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Autocomplete
                  id="disable-close-on-select"
                  // disableCloseOnSelect
                  options={filteredSubCat}
                  getOptionLabel={(option) => option.subcategoryName || ""}
                  value={
                    filteredSubCat.find(
                      (sub) => sub._id === selectedSubCategoryId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setSelectedSubCategoryId(newValue?._id || null);

                    // Clear validation error
                    if (productErrors.subcategoryId) {
                      setProductErrors({
                        ...productErrors,
                        subcategoryId: "",
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sub Category *"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                      error={!!productErrors.subcategoryId}
                      helperText={productErrors.subcategoryId}
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Autocomplete
                  id="disable-close-on-select"
                  // disableCloseOnSelect
                  options={filteredModel}
                  getOptionLabel={(option) => option.modelName || ""}
                  value={
                    filteredModel.find(
                      (model) => model._id === selectedModelId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    setSelectedModelId(newValue?._id || null);

                    // Clear validation error
                    if (productErrors.modelId) {
                      setProductErrors({
                        ...productErrors,
                        modelId: "",
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Model *"
                      variant="standard"
                      style={{ width: "12.5rem" }}
                      error={!!productErrors.modelId}
                      helperText={productErrors.modelId}
                    />
                  )}
                />
              </Grid>

              <Grid item>
                <Calendar
                  value={formDataProduct.invoiceDate}
                  handleChange={handleChange}
                  fieldName="invoiceDate"
                  label="Invoice Date"
                  error={!!productErrors.invoiceDate}
                  helperText={productErrors.invoiceDate}
                  withPortal={true}
                  maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                />
              </Grid>

              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="standard-basic"
                  label="Invoice No."
                  variant="standard"
                  value={formDataProduct.invoiceNo}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormDataProduct({
                      ...formDataProduct,
                      invoiceNo: value,
                    });

                    // Clear validation error
                    if (productErrors.invoiceNo) {
                      setProductErrors({
                        ...productErrors,
                        invoiceNo: "",
                      });
                    }
                  }}
                  error={!!productErrors.invoiceNo}
                  helperText={productErrors.invoiceNo}
                />
              </Grid>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="standard-basic"
                  label="Serial No."
                  variant="standard"
                  value={formDataProduct.serialNo}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormDataProduct({
                      ...formDataProduct,
                      serialNo: value,
                    });

                    // Clear validation error
                    if (productErrors.serialNo) {
                      setProductErrors({
                        ...productErrors,
                        serialNo: "",
                      });
                    }
                  }}
                  error={!!productErrors.serialNo}
                  helperText={productErrors.serialNo}
                />
              </Grid>
              <Grid item>
                <TextField
                  style={{ width: "100%" }}
                  id="standard-basic"
                  label="Purchased From"
                  variant="standard"
                  value={formDataProduct.purchasedFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormDataProduct({
                      ...formDataProduct,
                      purchasedFrom: value,
                    });

                    // Clear validation error
                    if (productErrors.purchasedFrom) {
                      setProductErrors({
                        ...productErrors,
                        purchasedFrom: "",
                      });
                    }
                  }}
                  error={!!productErrors.purchasedFrom}
                  helperText={productErrors.purchasedFrom}
                />
              </Grid>
              <Grid item>
                <div className="textinput-ClientOrganization">
                  <input
                    style={{ border: 0, paddingTop: "20px" }}
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const fileExt = file.name.split('.').pop().toLowerCase();
                        const allowedExtensions = ["jpg", "jpeg", "png"];
                        
                        if (!allowedExtensions.includes(fileExt)) {
                          toast.error("Only JPG, JPEG, and PNG files are allowed");
                          e.target.value = "";
                          return;
                        }

                        setFormDataProduct({
                          ...formDataProduct,
                          image: file,
                        });

                        // Clear validation error
                        if (productErrors.image) {
                          setProductErrors({
                            ...productErrors,
                            image: "",
                          });
                        }
                      } else {
                        toast.error("Please select a valid image.");
                      }
                    }}
                  />
                  {productErrors.image && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "0.75rem",
                        marginTop: "3px",
                      }}
                    >
                      {productErrors.image}
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
            <Grid container gap={2}>
              <Grid item>
                <CommonButton
                  name={"Create"}
                  handleOnClick={handleCreateProduct}
                />
              </Grid>
              <Grid item>
                <CommonButton
                  name={"Cancel"}
                  handleOnClick={handleCancelProduct}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
      <Toaster />
      {loading && <Loader />}
    </Grid>
  );
};

export default Customerservice;
